<template>
  <layout>
    <core-view class="primary" fill-height>
      <v-container id="containerlogo">
        <v-banner elevation="8" width="100%" color="#fafafa" single-line sticky>
          <div class="text-center inline-block" id="titulo">
            <p>Office Line Brasil</p>
            <p>Peanuts to the World</p>
          </div>

          <v-img
            contain
            src="/img/icons/brasil.png"
            max-width="80px"
            max-height="80vh"
            width="100%"
            id="imgtitulo"
            class="inline-block"
          >
          </v-img>
        </v-banner>
        <v-img
          contain
          :src="$_emp_img"
          max-width="320px"
          max-height="80vh"
          id="logo"
        />
        <v-banner height="100px" :single-line="singleLineBool">
          <div
            id="tituloapp"
            class="display-2 font-weight-hign inline-block white--text text-center"
          >
            {{ appTitle }}
          </div>
          <v-icon class="icone" small color="white dark" dense>
            mdi-registered-trademark
          </v-icon>
        </v-banner>
      </v-container>

      <v-navigation-drawer
        app
        right
        stateless
        :value="true"
        :width="$_width"
        :color="$_background_color"
        :dark="$_isMobile"
      >
        <v-container justify-space-around align-center flex-column class='background'>
          <v-img
              contain
              src="/img/sol_varejo.png"
              max-height="15vh"
              width="100%"
              class='sol'
          />
          <div  v-if="$_isMobile">
            <div id='div-imagem'>
              <p class="text-center font-weight-bold">
                {{$_emp_desenvolvedora}}
              </p>
              <v-img
              contain
              :src="$_emp_img"
              max-width="225px"
              max-height="80px"
              width="34vw"
              id="logo"
              />
          </div>
            <v-banner class="text-center font-weight-bold black--text">
              {{ appTitle }}
              <v-icon x-small color="black dark" dense>
                mdi-registered-trademark
              </v-icon>
            </v-banner>
          </div>

          <div class='formulario-container'>
            <v-form
            ref="form"
            id="formulario"
            class="align-self-stretch"
            :disabled="loading"
            @submit.prevent="$_onSubmit"
            >
            
            <v-combobox
              v-model="model.idVendedor"
              :items="listaVendedores"
              :item-text="formatarVendedor"
              item-value="IdVendedor"
              label="Selecione o Vendedor"
              :disabled="loading"
              :loading="loadingList"
              :rules="[v => !!v || 'Vendedor é obrigatório']"
              id="input-codigo"
              @focus="$_imputFocus"
              @blur="$_imputBlur"
              light
              outlined
              dense
              hide-details="auto"
              class="mb-4"
              no-data-text="Nenhum vendedor encontrado"
              :return-object="false"
              attach
              rounded
            >
              <template v-slot:item="{ item }">
                <v-list-item-content v-if="typeof item === 'object' && item !== null">
                  <v-list-item-title>
                    <span class="font-weight-bold blue--text">{{ item.Codigo }}</span>
                    <span class="grey--text text--darken-2"> - {{ item.NomeVendedor }}</span>
                    <span v-if="item.CPF && formatarCPF(item.CPF)" class="grey--text text--darken-2"> - {{ formatarCPF(item.CPF) }}</span>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-content v-else>
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item-content>
              </template>

              <template v-slot:selection="{ item }">
                <span v-if="typeof item === 'object' && item !== null">
                  {{ item.Codigo }} - {{ item.NomeVendedor }}
                </span>
                
                <span v-else>
                  {{ 
                    (() => {
                      const vendedor = listaVendedores.find(v => v.IdVendedor === item);
                      return vendedor ? `${vendedor.Codigo} - ${vendedor.NomeVendedor}` : item;
                    })()
                  }}
                </span>
              </template>
            </v-combobox>

            <core-password-field
              label="Senha"
              :disabled="loading"
              type=text
              v-model="model.password"
              maxlength="20"
              id='input-password'
              @focus='$_imputFocus'
              @blur='$_imputBlur'
              light
            />

            <v-row class="my-0">
              <v-spacer />

              <v-btn
                rounded
                x-large
                type="submit"
                class="loginbtn rounded-r-1"
                :loading="loading"
                color="#4c6faf"
                :dark="$_isMobile"
                :style='cssBotao'
              >
                <v-icon left>mdi-login</v-icon>
                Entrar
              </v-btn>
            </v-row>
          </v-form>
          </div>
          <v-container class='bkg_container'>
            <v-img
              contain
              src="/img/Faixa_2.png"
              width="100%"
              class="plantstop animate"
              :style="hidePlant"
            />
            <v-img
              contain
              src="/img/Faixa_3.png"
              width="100%"
              class="plantsbottom animate"
              :style="hidePlant"
            />
            <div :style="hidePlant" class='empresa animate'>
              <p>{{empresa}}</p>
              <p>V180-090326-001</p>
            </div>
          </v-container>
        </v-container>
      </v-navigation-drawer>
    </core-view>
  </layout>
</template>

<script>
import { ROUTE_HOME } from '@/constants/ROUTES';
import SnackbarEvent from '@/events/SnackbarEvent';
import actionResolver from '@/mixins/actions-resolver';
import CoreView from '@/components/core/view/Index.vue';
import CorePasswordField from '@/components/core/password-field/Index.vue';
// import CoreCpfField from '@/components/core/cpf-field/Index.vue'; // Removido, não é mais usado
import { mapActions } from 'vuex';
import Layout from '@/layouts/base/Index.vue';
import { USER_STORAGE } from '@/constants/STORAGE';
import db from '@/plugins/dexie';
import * as STORAGE from '@/constants/STORAGE';
import storage from '@/services/storage';
import { IsOnline, SetupIsOnline } from '../../utils/isonline';

import api from '@/services/api-varejoweb'; 

// function getSessionStorage(key, defaultValue) {
//   return sessionStorage.getItem(key) ?? defaultValue;
// }

export default {
  name: 'ViewSignIn',

  components: {
    CoreView,
    CorePasswordField,
    Layout,
  },

  mixins: [
    actionResolver({
      $_login: 'auth/authenticate',
      $_loginLocal: 'auth/authenticateLocal',
      // $_getId: 'users/findByWebId',
    }),
  ],

  data() {
    return {
      appTitle: process.env.VUE_APP_PROJECT_NAME,
      appVersion: process.env.VUE_APP_VERSION,

      loading: false,
      mobile: false,
      cssBotao: 'margin-bottom: 0vh;border-bottom: 0vh;right: 21%; width: 60%;',
      hidePlant: '',
      singleLineBool: false,

      model: {
        idVendedor: null,
        password: null,
      },

      listaVendedores: [],
      loadingList: false,

      errors: {},
      empresa: null,

      onLine: navigator.onLine,
    };
  },

  computed: {
    $_isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    $_width() {
      return this.$_isMobile ? window.screen.width : 512;
    },
    $_background_color() {
      return this.$_isMobile ? 'primary' : 'white';
    },
    $_emp_img() {
      return this.imagemlogomarca ?? '/img/LogoHD.png';
    },
    $_btn_color() {
      return this.$_isMobile ? 'white' : 'primary';
    },
    $_emp_desenvolvedora() {
      return this.empresadesenvolvedora ?? 'Officeline Brasil';
    },
  },

  methods: {
    ...mapActions({
      $_login: 'auth/authenticate',
      $_empresa: 'empresa/find',
    }),

      obterVendedorObj(item) {
        if (!item) return null;
        if (typeof item === 'object') return item;
        return this.listaVendedores.find(v => v.IdVendedor === item) || null;
      },

    async $_getEmpresa() {
      try {
        let dadosEmpresa = await db.empresa.toCollection().first().catch(() => null);
        if (!dadosEmpresa && navigator.onLine) {
          try {
            const resposta = await this.$_empresa();
            dadosEmpresa = Array.isArray(resposta) ? resposta[0] : resposta;
          } catch (e) {
            console.warn('Erro ao buscar empresa via API na SignInView:', e);
          }
        }
        if (!dadosEmpresa) {
          const param = await db.parametro.toCollection().first().catch(() => null);
          if (param) dadosEmpresa = param;
        }
        if (dadosEmpresa) {
          this.empresa = dadosEmpresa.empnomeempresa || dadosEmpresa.NomeEmpresa || dadosEmpresa.empnomefantasia || dadosEmpresa.empresa || dadosEmpresa.nome || '';
        }
      } catch (e) {
        console.warn('Erro em $_getEmpresa na SignInView:', e);
      }
    },

    async $_buscarVendedores() {
      this.loadingList = true;
      try {
        let vendedores = [];
        if (navigator.onLine) {
          try {
            const response = await api.get('/vendedor/lista');
            vendedores = response.data.data || response.data; 
          } catch (e) {
            console.warn('Erro ao buscar vendedores na API, buscando no Dexie:', e);
          }
        }
        if (!vendedores || !vendedores.length) {
          const vendedoresDb = await db.vendedor.orderBy('vencodigo').toArray().catch(() => []) || await db.vendedor.toArray().catch(() => []);
          vendedores = vendedoresDb.map(v => ({
            IdVendedor: v.venidnuvem || v.idvendedor || v.vencodigo || v.id,
            Codigo: v.vencodigo || v.codigo || v.venidnuvem || v.id,
            NomeVendedor: v.vennome || v.nome || v.descricao,
            CPF: v.vencpf || v.cpf || ''
          }));
        }
        if (!vendedores || !vendedores.length) {
          const usuariosDb = await db.usuario.toArray().catch(() => []);
          vendedores = usuariosDb.map(u => ({
            IdVendedor: u.useidnuvem || u.usecpf || u.id,
            Codigo: u.usecpf || u.useidnuvem,
            NomeVendedor: u.usenome || 'Vendedor',
            CPF: u.usecpf || ''
          }));
        }

        const param = await db.parametro.toCollection().first().catch(() => null);
        if (param && param.paridvendedorlogado) {
          const jaExiste = vendedores.some(v => 
            String(v.IdVendedor) === String(param.paridvendedorlogado) || 
            String(v.Codigo) === String(param.parvendedorcodigo || param.paridvendedorlogado)
          );
          if (!jaExiste) {
            vendedores.unshift({
              IdVendedor: param.paridvendedorlogado,
              Codigo: param.parvendedorcodigo || param.paridvendedorlogado,
              NomeVendedor: param.parvendedornome || 'Vendedor Logado',
              CPF: ''
            });
          }
        }

        this.listaVendedores = vendedores;
      } catch (error) {
        console.error('Erro ao carregar lista de vendedores:', error);
      } finally {
        this.loadingList = false;
      }
    },

    formatarVendedor(item) {
      if (!item) return '';
      if (typeof item === 'string') return item;
      return `${item.Codigo} - ${item.NomeVendedor}`;
    },

    formatarCPF(cpf) {
      if (!cpf) return '';
      cpf = cpf.replace(/\D/g, '');
      return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },

    $_extrairMensagemErro(err) {
      if (err.response?.data) {
        const data = err.response.data;
        if (typeof data === 'string' && data.length < 200) return data;
        if (data.message && typeof data.message === 'string') return data.message;
        if (data.mensagem && typeof data.mensagem === 'string') return data.mensagem;
        if (data.error) {
          if (typeof data.error === 'string') return data.error;
          if (data.error.message && typeof data.error.message === 'string') return data.error.message;
        }
        if (data.msg && typeof data.msg === 'string') return data.msg;
        if (data.details?.messages) {
          if (typeof data.details.messages === 'string') return data.details.messages;
          if (Array.isArray(data.details.messages)) return data.details.messages.join(', ');
        }
      }
      if (err.message && err.message !== 'Error' && !err.message.includes('status code')) {
        return err.message;
      }
      return 'Senha incorreta ou credenciais inválidas';
    },

    async $_onSubmit() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;

      try {
        if (navigator.onLine && (await IsOnline())) {
          try {
            await this.$_onSubmitOnline();
            return;
          } catch (onlineError) {
            // Se a API retornou resposta HTTP (ex: 400, 401, 403, 404, 422), a conexão funcionou mas a senha/credenciais estão incorretas
            if (onlineError.response) {
              const status = onlineError.response.status;
              if (status >= 400 && status < 500) {
                const msg = this.$_extrairMensagemErro(onlineError);
                document.dispatchEvent(
                  new SnackbarEvent({ message: msg || 'Senha incorreta ou credenciais inválidas' })
                );
                return;
              }
            } else if (onlineError.message === 'Credenciais inválidas') {
              document.dispatchEvent(
                new SnackbarEvent({ message: 'Senha incorreta ou credenciais inválidas' })
              );
              return;
            }
            console.warn('Conexão online falhou, tentando autenticação local/offline:', onlineError);
          }
        }
        await this.$_onSubmitOffline();
      } catch (err) {
        console.error('Erro ao efetuar login:', err);
      } finally {
        this.loading = false;
      }
    },

    async $_onSubmitOnline() {
      const payloadLogin = {
        codigo: this.model.idVendedor,
        senha: this.model.password
      };

      await this.$_login(payloadLogin);

      const vendedorObj = this.listaVendedores.find(v => v.IdVendedor === this.model.idVendedor) ||
                          this.listaVendedores.find(v => String(v.Codigo) === String(this.model.idVendedor));

      const idStr = String(this.model.idVendedor);
      let user = await db.usuario.where({ usecpf: idStr }).first().catch(() => null);
      if (!user) {
        const idNum = parseInt(idStr);
        if (!isNaN(idNum)) {
          user = await db.usuario.where({ useidnuvem: idNum }).first().catch(() => null);
        }
      }

      const nomeVendedorStr = vendedorObj ? (vendedorObj.NomeVendedor || vendedorObj.nome || vendedorObj.vennome || '---') : '---';

      if (!user) {
        await db.usuario.add({ 
          usenome: nomeVendedorStr, 
          usecpf: idStr, 
          usesenha: String(this.model.password || ''),
          useidnuvem: this.model.idVendedor
        });
      } else {
        await db.usuario.update(user.id, {
          usenome: nomeVendedorStr !== '---' ? nomeVendedorStr : user.usenome,
          usecpf: idStr,
          usesenha: String(this.model.password || ''),
          useidnuvem: this.model.idVendedor
        });
      }

      sessionStorage.setItem(USER_STORAGE.useidnuvem, this.model.idVendedor);
      if (nomeVendedorStr !== '---') {
        sessionStorage.setItem('user:nomevendedor', nomeVendedorStr);
      }

      await this.$_loginLocal();

      try {
        const responseId = await api.get(`/vendedor/webid/${this.model.idVendedor}`);
        const idData = responseId.data.data || responseId.data; 

        if (idData) {
          const mult = Math.floor(Math.random() * (999 - 100 + 1) + 100);
          let hashId = ((idData.IdVendedor + mult) * 11) + 1;
          hashId = (`${mult}${hashId}`);
          storage.setItem(STORAGE.USER_STORAGE.userId, hashId);
        }
      } catch (e) {
        console.warn('Erro ao carregar webid:', e);
      }

      await this.$_salvarParametros();
      this.$router.replace(ROUTE_HOME.path);
    },

    async $_onSubmitOffline() {
      const idStr = String(this.model.idVendedor || '').trim();
      const senhaStr = String(this.model.password || '').trim();

      if (!idStr) {
        document.dispatchEvent(new SnackbarEvent({ message: 'Selecione o vendedor' }));
        return;
      }

      let user = await db.usuario.where('usecpf').equals(idStr).first().catch(() => null);
      if (!user) {
        const idNum = parseInt(idStr);
        if (!isNaN(idNum)) {
          user = await db.usuario.where('useidnuvem').equals(idNum).first().catch(() => null);
        }
      }

      const param = await db.parametro.toCollection().first().catch(() => null);
      const isParamMatch = param && (
        String(param.paridvendedorlogado) === idStr ||
        String(param.parvendedorcodigo) === idStr
      );

      let vendedorLocal = await db.vendedor.where('vencodigo').equals(parseInt(idStr) || idStr).first().catch(() => null);
      if (!vendedorLocal && !isNaN(parseInt(idStr))) {
        vendedorLocal = await db.vendedor.where('venidnuvem').equals(parseInt(idStr)).first().catch(() => null);
      }

      const senhaGravada = (user && user.usesenha) ? user.usesenha : (isParamMatch && param.parsenhaatual ? param.parsenhaatual : null);

      if (senhaGravada) {
        if (String(senhaGravada).trim() !== senhaStr) {
          document.dispatchEvent(new SnackbarEvent({ message: 'Senha incorreta' }));
          return;
        }
      }

      const temRegistroLocal = user || isParamMatch || vendedorLocal;

      if (temRegistroLocal) {
        if (!senhaGravada) {
          document.dispatchEvent(new SnackbarEvent({ 
            message: 'Para o primeiro acesso deste vendedor, é necessário realizar o login online.' 
          }));
          return;
        }

        const nomeVendedor = (user && user.usenome && user.usenome !== '---') 
          ? user.usenome 
          : (vendedorLocal ? (vendedorLocal.vennome || vendedorLocal.nome || vendedorLocal.descricao) : 'Vendedor');

        sessionStorage.setItem(USER_STORAGE.useidnuvem, idStr);
        if (nomeVendedor) {
          sessionStorage.setItem('user:nomevendedor', nomeVendedor);
        }

        await this.$_loginLocal();
        await this.$_salvarParametros();

        document.dispatchEvent(new SnackbarEvent({ message: 'Login realizado em modo Offline' }));
        this.$router.replace(ROUTE_HOME.path);
      } else {
        document.dispatchEvent(new SnackbarEvent({ message: 'Sem conexão com a API e nenhum registro offline encontrado para este código.' }));
      }
    },

    $_imputFocus() {
      setTimeout(() => {
        const els = document.querySelectorAll('.animate');
        els.forEach((element) => {
          element.classList.add('fade');
        });
      }, 150);
    },

    $_imputBlur() {
      setTimeout(() => {
        const els = document.querySelectorAll('.animate');
        els.forEach((element) => {
          element.classList.remove('fade');
        });                                                                                                               
      }, 150);
    },

    async $_salvarParametros() {
      try {
        const idVendedor = this.model.idVendedor;
        const senha = this.model.password;

        const vendedorObj = this.listaVendedores.find(v => v.IdVendedor === idVendedor) ||
                            this.listaVendedores.find(v => String(v.Codigo) === String(idVendedor)) ||
                            this.listaVendedores.find(v => String(v.IdVendedor) === String(idVendedor));

        const codigoStr = vendedorObj ? (vendedorObj.Codigo || idVendedor) : idVendedor;
        const nomeStr = vendedorObj ? (vendedorObj.NomeVendedor || vendedorObj.nome || vendedorObj.vennome || '') : '';

        const paramData = {
          paridvendedorlogado: idVendedor,
          parvendedorcodigo: codigoStr,
          parvendedornome: nomeStr,
          parsenhaatual: senha
        };

        const param = await db.parametro.toCollection().first();
        if (param) {
          await db.parametro.update(param.id, paramData);
        } else {
          await db.parametro.add(paramData);
        }

        if (idVendedor) {
          const idStr = String(idVendedor);
          let user = await db.usuario.where({ usecpf: idStr }).first().catch(() => null);
          if (!user && !isNaN(parseInt(idStr))) {
            user = await db.usuario.where({ useidnuvem: parseInt(idStr) }).first().catch(() => null);
          }
          if (!user) {
            await db.usuario.add({
              usenome: nomeStr || 'Vendedor',
              usecpf: String(codigoStr),
              usesenha: String(senha || ''),
              useidnuvem: idVendedor
            });
          } else {
            await db.usuario.update(user.id, {
              usenome: nomeStr && nomeStr !== '---' ? nomeStr : user.usenome,
              usecpf: String(codigoStr),
              usesenha: String(senha || ''),
              useidnuvem: idVendedor
            });
          }
        }
      } catch (err) {
        console.error('Erro ao salvar parametros de login:', err);
      }
    },

    async $_carregarParametros() {
      try {
        const param = await db.parametro.toCollection().first();
        if (param) {
          this.model.idVendedor = param.paridvendedorlogado || null;
          this.model.password = param.parsenhaatual || null;
          if (param.parvendedornome) {
            sessionStorage.setItem('user:nomevendedor', param.parvendedornome);
          }
        }
      } catch (err) {
        console.error('Erro ao carregar parametros de login:', err);
      }
    },
  },

  async created() {
    SetupIsOnline();
    this.$_getEmpresa();
    await this.$_buscarVendedores();
    await this.$_carregarParametros();
  },

};
</script>
<style scoped>

.background {
  background-color: #ffffff;
}

#containerlogo {
  padding: 0px;
  height: 100%;
  display: inline;
}

#titulo {
  float: right;
  padding: 5px;
}

#titulo p {
  margin-top: 0px;
  margin-bottom: 0px;
  text-align: center;
}

#logo {
  margin-left: auto;
  margin-right: auto;
  margin-top: 5%;
}

.icone {
  vertical-align: text-top;
  display: inline-block;
}

#tituloapp {
  display: inline-block;
  margin-left: 40%;
  padding: 5px;
}

/* ===== FORMULARIO ===== */

#formulario {
  margin-top: 10vh;
  min-height: 61vh;
  max-width: 525px;
  margin-top: 1vh;
  padding: 0px;
  border: 0px;
  flex-grow: 1;
}

.formulario-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

/* html, body { overflow:hidden; } */

#input-cpf {
  max-width: 525px;
}

#input-password {
  max-width: 525px;
}

.loginbtn {
  color: white;

}

/* ===== FOOTER E PLANTAS ===== */

@keyframes sobePlanta {
  0% {
    transform: translateY(150%);
  }
  100% {
    transform: translateY(0%);
  }
}

@keyframes sobePlantaTABLET {
  0% {
    transform: translateY(150%);
  }
  100% {
    transform: translateY(25%);
  }
}

@keyframes desceSol {
  0% {
    transform: translateY(-150%);
  }
  100% {
    transform: translateY(-15%);
  }
}

.sol {
  transform: translateY(-150%);
  animation: 1.2s desceSol 0.3s 1 forwards;
}



.plantstop {
  transform: translateY(150%);
  position: absolute;
  bottom: 40px;
  left: 0px;
}

.plantsbottom {
  transform: translateY(150%);
  position: absolute;
  bottom: 0px;
  left: 0px;
}

.empresa {
  transform: translateY(150%);
  position: absolute;
  bottom: 5px;
  padding: 0px 10px 0px 10px;
  left: 0px;
  color: white;
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.animate {
  animation: 1.2s sobePlanta 0.3s 1 forwards;
}

.fade {
  opacity: 0;
}

</style>
